const testimonials = [
  {
    name: '吃瓜前线小能手',
    role: '资深瓜友',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20studio%20photography%2C%20professional%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '自从关注了911吃瓜网，再也不用到处翻八卦了！更新速度是真的快，每次有大瓜这里都是第一时间出稿，而且料都很扎实。',
    rating: 5,
  },
  {
    name: '娱乐圈观察员',
    role: '自媒体人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20Chinese%20woman%20portrait%2C%20modern%20style%2C%20studio%20photography%2C%20clean%20background%2C%20confident%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '做自媒体三年了，911吃瓜网是我每天必刷的平台。他们的独家爆料经常比主流媒体快好几个小时，时效性真的太强了。',
    rating: 5,
  },
  {
    name: '理性吃瓜人',
    role: '产品经理',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20with%20glasses%20portrait%2C%20professional%20studio%20photography%2C%20clean%20white%20background%2C%20thoughtful%20expression&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '对比了好几个吃瓜平台，911的内容质量明显更胜一筹。不是那种捕风捉影的营销号，每条爆料都有来源和细节，让人看得放心。',
    rating: 5,
  },
  {
    name: '八卦重度患者',
    role: '大学生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20student%20portrait%2C%20bright%20studio%20photography%2C%20clean%20background%2C%20happy%20expression&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '室友推荐的，结果一发不可收拾！每天晚上睡前必须刷一遍才安心，室友说我中毒了哈哈。不过这上面瓜确实又多又香！',
    rating: 5,
  },
  {
    name: '爆料小王子',
    role: '社群运营',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20in%20casual%20style%2C%20studio%20photography%2C%20clean%20white%20background%2C%20cool%20expression&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '在911上投过几次稿，审核速度很快，而且真的会保护投稿人隐私。作为一个爆料爱好者，找到这样一个靠谱的平台不容易。',
    rating: 4,
  },
  {
    name: '追瓜不迷路',
    role: '上班族',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20office%20lady%20portrait%2C%20professional%20studio%20photography%2C%20clean%20white%20background%2C%20warm%20smile&width=100&height=100&seq=avatar-06&orientation=squarish',
    content: '通勤路上必看的网站！分类很清晰，想找什么类型的瓜一目了然。而且界面没有乱七八糟的广告，浏览体验比别的平台好太多了。',
    rating: 5,
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block w-2 h-2 bg-accent-500 rounded-full mb-3"></span>
          <span className="block text-xs text-foreground-400 mb-4">瓜友热议</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            百万瓜友的真实评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听吃瓜群众们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className={`p-6 rounded-xl bg-background-50 border border-background-200/70 ${
                index >= 3 ? 'opacity-70' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-2">
                {item.name}
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}